import type { BadgeVariant } from "@/components/ui/badge/badge.variants";
import { PayrollRunStatusEnum } from "@/utils/enums/payroll.enum";

// Payroll runs have 8 lifecycle states but the badge system has 6 variants.
// The global statusToVariant maps both APPROVED and COMPLETED to `success`,
// which makes them indistinguishable here. Payroll needs each lifecycle stage
// to read as a distinct color, so it resolves its own variant locally instead
// of mutating the shared STATUS_MAP (where `approved` must stay green).
//
// GENERATING → DRAFT → IN_REVIEW → APPROVED → PROCESSING → COMPLETED
//                                                ↘ CANCELLED / FAILED
const PAYROLL_RUN_VARIANT: Record<PayrollRunStatusEnum, BadgeVariant> = {
  [PayrollRunStatusEnum.DRAFT]: "neutral",
  [PayrollRunStatusEnum.GENERATING]: "info",
  [PayrollRunStatusEnum.IN_REVIEW]: "warning",
  [PayrollRunStatusEnum.APPROVED]: "primary",
  [PayrollRunStatusEnum.PROCESSING]: "info",
  [PayrollRunStatusEnum.COMPLETED]: "success",
  [PayrollRunStatusEnum.CANCELLED]: "neutral",
  [PayrollRunStatusEnum.FAILED]: "danger",
};

export function payrollRunStatusToVariant(
  status: string | null | undefined,
): BadgeVariant {
  if (!status) return "neutral";
  const key = String(status).toUpperCase().replace(/[\s-]+/g, "_");
  return PAYROLL_RUN_VARIANT[key as PayrollRunStatusEnum] ?? "neutral";
}
